export default {
  cbam_news: "Actualités CBAM",
  view_all_news: "Voir toutes les actualités",
  search_news: "Rechercher des actualités...",
  no_news: "Aucune actualité disponible",
  fetch_news_failed: "Échec de la récupération des actualités",
};
